import { AffiliateLink } from "./types/affiliate_link"

export const countryCodeFilter = (link: AffiliateLink) => !!link.countryCode;

export const streamRentBuyFilter = (link: AffiliateLink) => !!link.option && Array.prototype.constructor('Stream', 'Rent', 'Buy').includes(link.option);

/** ['US','CA'] = filter to those; [] / null = all countries */
export const GEO_WHITELIST_COUNTRY_CODES: any = [];

function escapeHtml(value: any): string {
    return String(value || '').replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
}

function getIconUrl(link: any): string {
    const ss = link && link.streamingService;
    return (ss && ss.iconImage && ss.iconImage.url) || (ss && ss.image && ss.image.url) || (link && link.iconImage && link.iconImage.url) || '';
}

function getStreamRentBuyLinks(tag: any): any[] {
    if (!tag) return [];
    const allowed = Array.isArray(GEO_WHITELIST_COUNTRY_CODES) ? GEO_WHITELIST_COUNTRY_CODES.map((c) => String(c).toUpperCase()) : [];
    const raw =
        (tag.details && tag.details.affiliateLinks && tag.details.affiliateLinks.length && tag.details.affiliateLinks)
        || (tag.defaults && tag.defaults.affiliateLinks && tag.defaults.affiliateLinks.length && tag.defaults.affiliateLinks)
        || (tag.affiliateLinks && tag.affiliateLinks.length && tag.affiliateLinks)
        || [];

    return raw.filter((link) => {
        if (!link || !link.value || ['Stream', 'Rent', 'Buy'].indexOf(link.option) === -1 || !getIconUrl(link)) return false;
        if (!allowed.length) return true;
        const cc = link.countryCode ? String(link.countryCode).toUpperCase() : '';
        return !cc || allowed.indexOf(cc) !== -1;
    });
}

function buildListItems(links: any[]): string {
    return links.map((link) => {
        const cc = link.countryCode ? String(link.countryCode).toUpperCase() : '';
        const opt = String(link.option || '');
        const attrs = (cc ? ` data-country-code="${escapeHtml(cc)}"` : '') + (opt ? ` data-option="${escapeHtml(opt)}"` : '');
        return `<li${attrs}><a href="${escapeHtml(link.value)}" rel="noopener noreferrer nofollow sponsored" target="_blank"><img src="${escapeHtml(getIconUrl(link))}" alt="${escapeHtml(link.type || opt || 'Watch')}" width="75" height="75" loading="lazy" /></a></li>`;
    }).join('');
}

function buildOptionSection(cls: string, title: string, listClass: string, links: any[], wrapFlex: boolean): string {
    const listItems = buildListItems(links);
    if (!listItems) return '';
    const list = `<ul${listClass ? ` class="${listClass}"` : ''}>${listItems}</ul>`;
    return `<div class="${cls}"><strong>${title}</strong>${wrapFlex ? `<div class="flex">${list}</div>` : list}</div>`;
}

/** Where-to-watch HTML for vignette preview/insert. */
export function buildStreamingServiceHtmlFromTag(tag: any): string {
    const links = getStreamRentBuyLinks(tag);
    if (!links.length) return '';

    const stream = links.filter((l) => l.option === 'Stream');
    const rent = links.filter((l) => l.option === 'Rent');
    const buy = links.filter((l) => l.option === 'Buy');
    const previewItems = buildListItems(stream.concat(rent, buy).slice(0, 3));
    const previewHtml = previewItems ? `<div class="preview-links"><ul>${previewItems}</ul></div>` : '';
    const streamHtml = buildOptionSection('streaming', 'Streaming', '', stream, false);
    const rentHtml = buildOptionSection('rent-buy', 'RENT', 'listing-rent-items', rent, true);
    const buyHtml = buildOptionSection('rent-buy', 'BUY', 'listing-buy-items', buy, true);
    if (!previewHtml && !streamHtml && !rentHtml && !buyHtml) return '';

    const id = `where-to-watch-${tag && tag.id ? tag.id : 'preview'}`;
    const body = `${streamHtml}${rentHtml}${buyHtml}`;
    const popup = body
                ? `<input type="checkbox" id="${id}" name="where-to-watch" class="css-menu-checkbox">
        <label for="${id}" class="listing-screen-cta where-to-watch-cta css-menu-toggle"><i class="icon i-plus-solid"></i></label>
        <div class="where-to-watch-list css-menu-target">
        <div class="w-where-to-watch-list">${body}</div>
        </div>`
                : '';

    return `<div class="w-listing-screen-cta w-where-to-watch">${previewHtml}${popup}</div>`;
}



// WEBPACK FOOTER //
// ./js/utils/AffiliateLinkHelper.ts